// extracted by mini-css-extract-plugin
export default {"photoPost":"UserPhotoPost_photoPost__k8Gw-","file":"UserPhotoPost_file__YqWuJ","preview":"UserPhotoPost_preview__OrQI0"};